import { AppImageClient } from '@components/appImage';
import Link from 'next/link';

import { AllCasesCardProps } from './types';

import IconArrow from '@/assets/icons/iconArrow.svg';

const AllCasesCard = ({ link, target, text, bgData }: AllCasesCardProps) => (
  <div className="rounded-20 bg-surface-base-secondary relative flex h-full items-center justify-center hover:cursor-pointer max-sm:hover:cursor-default">
    <AppImageClient
      {...bgData}
      alt="cases-slider-overlay"
      className="rounded-20 pointer-events-none absolute top-0 left-0 h-full w-full object-cover"
    />

    <Link
      target={target}
      href={link}
      className="bg-custom-base-inverse-primary text-custom-base-primary hover:bg-custom-base-inverse-secondary relative flex h-[56px] w-fit cursor-pointer items-center justify-center rounded-xl px-6 transition-colors duration-300"
    >
      {text}
      <IconArrow className="ml-2 h-[24px] w-[24px] rotate-[-45deg]" />
    </Link>
  </div>
);
export default AllCasesCard;
